/**
 * Invoicing Health Data
 *
 * Various selectors using reselect for selecting data from state
 *
 */
import _values from 'lodash/values';
import { COLLECTIONS } from 'state/snapi/slice';

const stateSelector = state => state.snapi[COLLECTIONS.INVOICING_HEALTH];
const isFetchingSelector = state => stateSelector(state).isFetching;
const itemSelector = state => stateSelector(state).items;

export const selectInvoicingHealthIsFetching = state => isFetchingSelector(state);

export const selectInvoicingHealthValues = state => _values(itemSelector(state))[0] || {};

export const selectInvoicingHealth = state => itemSelector(state);
